<div class="page-layout carded fullwidth inner-scroll" id="upClass">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0"></h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <div class="card" style="width: 100%;">
                <!--MENU SUPERIOR-->
            </div>
            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span> </span>
            </div>
            <!-- / CONTENT TOOLBAR -->
            <!-- CONTENT -->
            <div class="content-card mainDiv" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;">
                <div aling="center">
                    <img src="{{urlBanner}}" alt="Logo-Norm35" class="centradoIMG ">
                </div><br>
                <p>{{ 'WIZARD.Guia4.TITLE' | translate}}</p>
                <p> {{ 'WIZARD.Guia4.SUBTITLE' | translate}} </p>
                <span>{{ 'WIZARD.Guia4.CONTENT' | translate}}</span>

                <div class="container">
                    <div>
                        <p>
                            {{ 'WIZARD.Guia4.MAIN_CONTENT.TITLE' | translate}}
                        </p>
                    </div>
                    <p> {{ 'WIZARD.Guia4.MAIN_CONTENT.PAF1' | translate}}</p>
                    <p> {{ 'WIZARD.Guia4.MAIN_CONTENT.PAF2' | translate}}</p>
                    <p> {{ 'WIZARD.Guia4.MAIN_CONTENT.PAF3' | translate}}</p>
                    <p> {{ 'WIZARD.Guia4.MAIN_CONTENT.PAF4' | translate}} </p>
                    <p> {{ 'WIZARD.Guia4.MAIN_CONTENT.PAF5' | translate}}</p>
                    <p>Nota:</p>
                    <p> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.DES' | translate}} </p>
                    <p>{{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT1' | translate}}</p>

                    <ul> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT1_P.A' | translate}}</ul>
                    <ul> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT1_P.B' | translate}} </ul>
                    <ul> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT1_P.C' | translate}} </ul>
                    <ul> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT1_P.D' | translate}}</ul>
                    <ul> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT1_P.E' | translate}} </ul>
                    <ul> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT1_P.F' | translate}} </ul>
                    <ul> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT1_P.G' | translate}} </ul>
                    <ul> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT1_P.H' | translate}} </ul>

                    <p> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT2' | translate}} </p>
                    <p> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT3' | translate}} </p>
                    <p> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT4' | translate}} </p>
                    <p> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT5' | translate}}</p>
                    <p> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT6' | translate}} </p>
                    <p> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT7' | translate}}
                        <p> {{ 'WIZARD.Guia4.MAIN_CONTENT.NOTA.NOT8' | translate}} </p>

                </div><br><br>
            </div>
            <!--END FIRTS SECCION-->



            <!--END SECONND SECCION-->

            <!--<div *ngIf=" dataId.id == datita.position ">-->
        </div>

        <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

</div>
<!-- / CENTER -->